import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col, Card, Container } from "react-bootstrap";

const baseURL = process.env.REACT_APP_API_JOBS;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const Add = ({
  mekhraz_id,
  SetIsAdded,
  assessmentTypeOptions,
  mazmeenTypeOptions,
  evaluationInstitutes,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const [error, setError] = useState(false);
  const toDay = new Date();
  const dateS =
    toDay.getFullYear() +
    "-" +
    ("0" + (toDay.getMonth() + 1)).substr(-2) +
    "-" +
    ("0" + toDay.getDate()).substr(-2);
  const timeS =
    ("0" + toDay.getHours()).substr(-2) +
    ":" +
    ("0" + toDay.getMinutes()).substr(-2);

  const [inputField, setInputField] = useState({
    assessment_type: "E",
    mazmeen_type: "R",
    address: "",
    mefakeh: "",
    notes: "",
    attend: false,
    mekhraz: mekhraz_id,
    evaluationinstitute: "",
  });
  const [reasonIsRequired, setReasonIsRequired] = useState(false);

  // handle change event
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "attend") {
      inputField.attend = e.target.checked;
      setReasonIsRequired((prev) => !prev);
    } else {
      setInputField((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const controller = new AbortController();
    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "assessment/",
          inputField,
          {
            signal: controller.signal,
          }
        );
        alert("פרטי המבחן עודכנו");
        //isMounted &&
        SetIsAdded((prev) => !prev);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    //setTitle("");
    setError(false);
  };

  return (
    <Card className="success container px-5 " bg="light">
      <Card.Header className="mx-auto">
        <h4>פרטי מבחן מיון/הערכה</h4>
      </Card.Header>
      <Card.Body className="mx-auto">
        <form onSubmit={handleSubmit}>
          <Container>
            <Row>
              <Col>
                <div className="form-group">
                  <label>סוג ההערכה</label>
                  <br />
                  <select
                    name="assessment_type"
                    onChange={handleChange}
                    value={inputField.assessment_type}
                    required
                  >
                    <option key="0" value="" selected>
                      בחר סוג
                    </option>
                    {assessmentTypeOptions?.map((a) => (
                      <option key={a[0]} value={a[1]}>
                        {a[1]}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group">
                  <label htmlFor="mazmeen_type">המזמין למבחן</label>
                  <br />
                  <select
                    name="mazmeen_type"
                    onChange={handleChange}
                    value={inputField.mazmeen_type}
                    required
                  >
                    <option key="0" value="" selected>
                      בחר סוג
                    </option>
                    {mazmeenTypeOptions?.map((a) => (
                      <option key={a[0]} value={a[1]}>
                        {a[1]}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <label htmlFor="evaluationinstitute"> מכון המיון</label>
                <br />
                <select
                  name="evaluationinstitute"
                  onChange={handleChange}
                  value={inputField.evaluationinstitute}
                  required
                >
                  <option value="" selected>
                    בחר מכון
                  </option>
                  {evaluationInstitutes?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.title}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>

            <Row>
              {" "}
              <Col>
                <label htmlFor="mefakeh">שם המפקח על המבחן</label>
                <input
                  type="text"
                  name="mefakeh"
                  value={inputField.mefakeh}
                  onChange={handleChange}
                  className="form-control"
                  id="mefakeh"
                  placeholder=""
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <label htmlFor="took_place"> המבחן התקיים?</label>
                <br />
                <input
                  type="checkbox"
                  id="took_place"
                  name="took_place"
                  checked={inputField.took_place}
                  onChange={handleChange}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <label htmlFor="notes">הערות</label>
                <textarea
                  name="notes"
                  style={{ minWidth: "400px" }}
                  value={inputField.notes}
                  onChange={handleChange}
                  className="form-control"
                  id="notes"
                  placeholder=""
                />
              </Col>
            </Row>

            <button type="submit" className="btn btn-primary">
              שמור
            </button>
          </Container>
        </form>
      </Card.Body>
    </Card>
  );
};

export default Add;
